import React from "react";
import {
  AppContainer,
  AppMainContent,
  AppContent,
  AppFooter,
  NotificationContainer,
  LoadingIndicator,
} from "@abb/abb-common-ux-react";

import ActionHeader from "./ActionHeader";

import notificationStore from "../../flux/stores/shared/NotificationStore";

import INotificationData from "../../models/shared/NotificationData";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import loadingIndicatorStore from "../../flux/stores/shared/LoadingStore";
import { CHANGE_EVENT } from "../../utilities/Constants";
import ErrorBoundary from "./ErrorBoundary";
import DateTimeActions from "../../flux/actions/DateTimeActions";
import DateTimeStore from "../../flux/stores/sample/DateTimeStore";

interface IMainLayoutState {
  notifications: any[];
  text: string;
  name: string;
  secondMsg: string;
  isLoading: boolean;
}

export default class MainLayout extends React.Component<
  { location: any },
  IMainLayoutState
> {
  _mount: boolean;
  _version: any;

  constructor(props: { location: any }) {
    super(props);

    this._mount = false;
    this.state = {
      notifications: [],
      text: "",
      name: "",
      secondMsg: "",
      isLoading: true,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    DateTimeActions.getAll().then(() => { });
    DateTimeStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      const dateObject = state.dateTimeFormatList;
      localStorage.setItem("dateObject", JSON.stringify(dateObject));
    });


    notificationStore.on(CONSTANTS.CHANGE_EVENT, (state: INotificationData) => {
      if (this._mount) {
        const notification = {
          type: "banner",
          severity: [state.severity],
          timeout: CONSTANTS.UI_NOTIFICATION_TIMEOUT,
          text: "",
        };
        const data = state.data;
        let name: string = "";
        let secondMsg: string = "";
        if (data !== undefined) {
          if (data.length > 0) {
            if (data.length === 1) {
              name = data[0];
            } else {
              name = data[0];
              secondMsg = data[1];
            }
          }
        }

        this.setState({
          notifications: this.state.notifications.concat(notification),
          text: state.message,
          name,
          secondMsg,
        });
      }
    });

    loadingIndicatorStore.on(CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        setTimeout(() => {
          this.setState({
            isLoading: state.data,
          });
        }, 2000);
      }
    });
  }

  public render() {
    return (
      <React.Fragment>
        {this.state.isLoading && (
          <div
            style={{
              background: "black",
              width: "100%",
              height: "100vh",
              position: "fixed",
              zIndex: 11111,
              opacity: 0.6,
            }}
          >
            <div style={{ top: "42vh", left: "45vw", position: "absolute" }}>
              <LoadingIndicator
                determinate={false}
                type="radial"
                color="blue"
                sizeClass="large"
              />
            </div>
          </div>
        )}

        <Translation>
          {(t) => (
            <AppContainer>
              <AppContent>
                <AppMainContent className="page-scroll">
                  <ActionHeader {...this.props} />
                  <ErrorBoundary loc={this.props.location}>
                    {this.props.children}
                  </ErrorBoundary>
                </AppMainContent>
              </AppContent>
              <AppFooter showLogo>
                {t(CONSTANTS.v)} {"0.21.40"} {t(CONSTANTS.BUILT)}: {"2:37:48 PM"}
              </AppFooter>
              <NotificationContainer
                notifications={this.state.notifications.filter(
                  (x) =>
                  (x.text = t(this.state.text, {
                    name: this.state.name,
                    secondmsg: this.state.secondMsg,
                  }))
                )}
                actionHandler={{ remove: () => { } }}
                style={{
                  top: '-5px',
                  right: "0",
                  zIndex: 10000,
                  width: 490
                }}
              />
            </AppContainer>
          )}
        </Translation>
      </React.Fragment>
    );
  }
}
